import clsx from 'clsx';

import Label from '@frontend/storefront/components/label';
import Image from '@frontend/storefront/Image';

export function GridTileImage({
  isInteractive = true,
  active,
  label,
  src,
  ...props
}: {
  isInteractive?: boolean;
  active?: boolean;
  label?: {
    title: string;
    amount: string;
    currencyCode: string;
    position?: 'bottom' | 'center';
  };
} & Omit<React.ComponentProps<typeof Image>, 'src'> & {
    src?: React.ComponentProps<typeof Image>['src'];
  }) {
  return (
    <div
      className={clsx(
        'group flex h-full w-full items-center justify-center overflow-hidden rounded-np-md border bg-np-card hover:border-np-pink',
        {
          relative: label,
          'border-2 border-np-pink': active,
          'border-transparent': !active,
        },
      )}
    >
      {src ? (
        <Image
          src={src}
          className={clsx('relative h-full w-full object-contain', {
            'transition duration-300 ease-in-out group-hover:scale-105':
              isInteractive,
          })}
          {...props}
        />
      ) : null}
      {label ? (
        <Label
          title={label.title}
          amount={label.amount}
          currencyCode={label.currencyCode}
          position={label.position}
        />
      ) : null}
    </div>
  );
}
